// extracted by mini-css-extract-plugin
export var attachment = "_pt-a";
export var emailContainer = "_pt-4";
export var emailContentPaddedContainer = "_pt-b";
export var emailHeader = "_pt-6";
export var emailIframe = "_pt-3";
export var emailInfoIcon = "_pt-9";
export var emailShortenedSummary = "_pt-e";
export var infoDropdown = "_pt-0";
export var infoRowBoundedContent = "_pt-d";
export var internal = "_pt-5";
export var merchant = "_pt-8";
export var messageInputContainer = "_pt-h";
export var normal = "_pt-7";
export var replyCard = "_pt-f";
export var subtleButton = "_pt-1";
export var subtleButtonIconContainer = "_pt-2";
export var toggleViewRepliesButton = "_pt-c";
export var wrappingText = "_pt-g";